export const rulesList = [
  {
    label: "user",
    options: [
      {
        label: "is",
        options: ["logged"],
      },
      {
        label: "has",
        options: ["active_subscription"],
      },
      {
        label: "has_not",
        options: ["active_subscription"],
      },
      {
        label: "is_not",
        options: ["logged"],
      },
    ],
  },
];

export const rulesConflicts = [
  {
    operator: "is",
    predicat: "logged",
    conflicts_with: [{ type: "user", operator: "is_not", predicat: "logged" }],
  },
  {
    operator: "has",
    predicat: "active_subscription",
    conflicts_with: [
      { type: "user", operator: "is_not", predicat: "logged" },
      { type: "user", operator: "has_not", predicat: "active_subscription" },
    ],
  },
  {
    operator: "has_not",
    predicat: "active_subscription",
    conflicts_with: [
      { type: "user", operator: "has", predicat: "active_subscription" },
    ],
  },
  {
    operator: "is_not",
    predicat: "logged",
    conflicts_with: [
      { type: "user", operator: "is", predicat: "logged" },
      { type: "user", operator: "has", predicat: "active_subscription" },
      { type: "user", operator: "has_not", predicat: "active_subscription" },
    ],
  },
];
